module.exports = __webpack_public_path__ + "gif/wrong-4.gif";